import React from "react";
import { Photographer } from "./useFilteredPhotographers";
const noEvents = require("./images/dark-no-imgs.svg");
const gssNewLoader = require("../../../public/images/website/photographer/gss-loader.gif");

const PhotographersList = ({
  photographers,
  loading
}: {
  photographers: Photographer[];
  loading: boolean;
}) => {
  const renderEvent = (photographer: Photographer) => (
    <a
      href={photographer.browsePhotographersPath}
      target="_blank"
      key={photographer.id}
      className="ev__single ev--ph-list bg-lt-green flex-row"
    >
      <span className="ev__text">
        <span className="ev__title">{photographer.name}</span>
        <span className="ev__info">
          <span className="darker">{photographer.photosCount || 0}</span> photos
          <span className="divi">•</span>
          <span className="darker">{photographer.albumsCount}</span> albums
        </span>
      </span>
      {!!photographer.profilePicture && (
        <span
          className="ph-pro-pic-container"
          style={{ backgroundImage: "url(" + photographer.profilePicture + ")" }}
        ></span>
      )}
    </a>
  );

  return (
    <section className="s-results date-results ns ev">
      <div className="container">
        {loading ? (
          <div className="gss-loader">
            <img src={gssNewLoader} />
          </div>
        ) : (
          photographers.length === 0 && (
            <div className="no-results events text-center">
              <img src={noEvents} alt="" />
              <h6>No photographers found</h6>
            </div>
          )
        )}
        {photographers.map(photographer => renderEvent(photographer))}
      </div>
    </section>
  );
};
export default PhotographersList;
